module.exports = __webpack_public_path__ + "img/petroci.cf0cba60.png";